import { useState, useCallback } from 'react';
import { p930hApi } from '../../../services/p930hApi';
import { dateToInput } from '../helpers';

export function useP930HNavigation(onNavigate: (dateStr: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  /** Load the full list of date IDs */
  const loadList = useCallback(async (): Promise<string[]> => {
    const res = await p930hApi.list(1, 10000);
    const ids = (res.data || [])
      .map(r => dateToInput(r.f90h_01))
      .filter(Boolean);
    setAllIds(ids);
    return ids;
  }, []);

  /** Navigate to a specific index */
  const navTo = useCallback(async (idx: number, isEditing: boolean) => {
    if (idx < 0 || idx >= allIds.length || isEditing) return;
    setCurrentIdx(idx);
    await onNavigate(allIds[idx]);
  }, [allIds, onNavigate]);

  return {
    allIds, currentIdx,
    setAllIds, setCurrentIdx,
    loadList, navTo,
  };
}
